import { useMemo } from 'react';

import { useApiQuery } from '@/hooks/api';
import { FACET_STALE_TIME } from '@/hooks/api/defaults';

type UseListingFilterCountsOptions<TCounts, TSidebar> = {
  queryKey: readonly unknown[];
  queryFn: () => Promise<TCounts | undefined>;
  mapToSidebar: (counts: TCounts | undefined) => TSidebar;
  enabled?: boolean;
};

export function useListingFilterCounts<TCounts, TSidebar>({
  queryKey,
  queryFn,
  mapToSidebar,
  enabled = true,
}: UseListingFilterCountsOptions<TCounts, TSidebar>): TSidebar {
  const { data: filterCounts } = useApiQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: FACET_STALE_TIME,
    placeholderData: (previous) => previous,
  });

  const countsKey = filterCounts ? JSON.stringify(filterCounts) : '';

  return useMemo(
    () => mapToSidebar(filterCounts),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- keyed by serialized content
    [countsKey],
  );
}
